import {
  useMemo,
  useState
} from "react";

import AnatomicalTooth from "../components/dental/AnatomicalTooth";


const CUADRANTES = {

  "Superior derecho": [
    "18",
    "17",
    "16",
    "15",
    "14",
    "13",
    "12",
    "11"
  ],

  "Superior izquierdo": [
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28"
  ],

  "Inferior izquierdo": [
    "38",
    "37",
    "36",
    "35",
    "34",
    "33",
    "32",
    "31"
  ],

  "Inferior derecho": [
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48"
  ]

};


const TEMPORALES = [

  [
    "E1",
    "D1",
    "C1",
    "B1",
    "A1"
  ],

  [
    "A2",
    "B2",
    "C2",
    "D2",
    "E2"
  ],

  [
    "E3",
    "D3",
    "C3",
    "B3",
    "A3"
  ],

  [
    "A4",
    "B4",
    "C4",
    "D4",
    "E4"
  ]

];


const COLORES_CONDICION = {

  "Caries": "#fee2e2",

  "Corona": "#fef3c7",

  "Endodoncia": "#ede9fe",

  "Implante": "#dbeafe",

  "Obturación": "#dcfce7",

  "Fractura": "#ffedd5",

  "Diente Ausente": "#e5e7eb",

  "Sano": "#dcfce7",

  "Pulpa normal": "#dcfce7",

  "Pulpitis reversible": "#fef3c7",

  "Pulpitis irreversible sintomática": "#fee2e2",

  "Pulpitis irreversible asintomática": "#fecaca",

  "Pulpitis hiperplásica": "#fce7f3",

  "Necrosis pulpar": "#e2e8f0",

  "Tratamiento previamente iniciado": "#ede9fe",

  "Tratamiento previamente realizado": "#e0e7ff",

  "Tejidos apicales normales": "#dcfce7",

  "Periodontitis apical sintomática": "#ffedd5",

  "Periodontitis apical asintomática": "#fed7aa",

  "Absceso apical agudo": "#fee2e2",

  "Absceso apical crónico": "#fecaca",

  "Osteítis condensante": "#f3e8ff",

  "Gingivitis": "#fce7f3",

  "Periodontitis localizada": "#fbcfe8",

  "Periodontitis generalizada": "#f9a8d4",

  "Recesión gingival": "#ffedd5",

  "Involucramiento de furca": "#fed7aa"

};


const CONDICIONES = [

  "Absceso",

  "Absceso apical agudo",

  "Absceso apical crónico",

  "Caries cavitada",

  "Caries recurrente",

  "Lesión inicial no cavitada",

  "Abrasión",

  "Brackets",

  "Caries",

  "Corona",

  "Restauración defectuosa",

  "Desgaste",

  "Diente Ausente",

  "Endodoncia",

  "Fístula",

  "Extracción indicada",

  "Fisura",

  "Fractura",

  "Gingivitis",

  "Hipoplasia",

  "Implante",

  "Pulpa normal",

  "Pulpitis reversible",

  "Pulpitis irreversible sintomática",

  "Pulpitis irreversible asintomática",

  "Pulpitis hiperplásica",

  "Necrosis pulpar",

  "Tratamiento previamente iniciado",

  "Tratamiento previamente realizado",

  "Tejidos apicales normales",

  "Periodontitis apical sintomática",

  "Periodontitis apical asintomática",

  "Osteítis condensante",

  "Gingivitis",

  "Periodontitis localizada",

  "Periodontitis generalizada",

  "Recesión gingival",

  "Involucramiento de furca",

  "Diente impactado",

  "Diente supernumerario",

  "Incrustación",

  "Movilidad",

  "Movilidad grado I",

  "Movilidad grado II",

  "Movilidad grado III",

  "Obturación",

  "Periodontitis",

  "Perno",

  "Placa",

  "Prótesis",

  "Reabsorción",

  "Reabsorción interna",

  "Reabsorción externa",

  "Lesión periapical",

  "Restauración provisional",

  "Sellante",

  "Sano"

].sort((a, b) =>
  a.localeCompare(
    b,
    "es"
  )
);


function obtenerCondicion(
  odontograma,
  diente
) {

  if (
    !odontograma ||
    !diente
  ) {

    return null;

  }


  if (
    odontograma[diente]
  ) {

    return odontograma[diente];

  }


  const claves =
    Object.keys(
      odontograma
    );


  const relacionadas =
    claves.filter(
      key =>
        key.startsWith(
          `${diente}_`
        )
    );


  if (
    relacionadas.length === 0
  ) {

    return null;

  }


  return {

    tipo: "cara",

    condicion:
      "Con condiciones"

  };

}


function Tooth({

  numero,

  odontograma,

  seleccionado,

  onSelect,

  compact = false

}) {

  const registroDiente =
    odontograma?.[numero];


  const condicionDiente =
    registroDiente?.condicion
    || "";


  const obtenerCondicionCara = (
    cara
  ) => {

    const registro =
      odontograma?.[
        `${numero}_${cara}`
      ];

    return registro?.condicion
      || "";

  };


  const esSuperior =

    numero.startsWith("1") ||

    numero.startsWith("2") ||

    numero.endsWith("1") ||

    numero.endsWith("2");


  const caraInterna =
    esSuperior
      ? "palatina"
      : "lingual";


  const condicionMesial =
    obtenerCondicionCara(
      "mesial"
    );


  const condicionDistal =
    obtenerCondicionCara(
      "distal"
    );


  const condicionVestibular =
    obtenerCondicionCara(
      "vestibular"
    );


  const condicionInterna =
    obtenerCondicionCara(
      caraInterna
    );


  const condicionOclusal =
    obtenerCondicionCara(
      "oclusal"
    );


  const colorCondicion = (
    condicion,
    colorBase = "#ffffff"
    ) => {

    if (
        condicion
    ) {

        return (
        COLORES_CONDICION[
            condicion
        ] ||
        "#fecaca"
        );

    }


    return colorBase;

  };

  const tieneCondicion =
    Boolean(
      condicionDiente ||
      condicionMesial ||
      condicionDistal ||
      condicionVestibular ||
      condicionInterna ||
      condicionOclusal
    );


  const borde =
    seleccionado === numero

      ? "#2563eb"

      : tieneCondicion

        ? "#64748b"

        : "#94a3b8";


  const grosorBorde =
    seleccionado === numero
      ? 3
      : 1.5;


  return (

    <button

      type="button"

      onClick={() =>
        onSelect(
          numero
        )
      }

      style={{

        width:
            compact ? 58 : 76,

        minWidth:
            compact ? 58 : 76,

        height:
            compact ? 78 : 92,

        padding: 0,

        border: "none",

        background:
          "transparent",

        cursor: "pointer",

        flexShrink: 0,

        display: "flex",

        flexDirection:
          "column",

        alignItems:
          "center",

        justifyContent:
          "flex-start"

      }}

    >

      <AnatomicalTooth
        numero={numero}
        compact={compact}
        selected={seleccionado === numero}
        absent={condicionDiente === "Diente Ausente"}
        colors={{
          vestibular: colorCondicion(condicionVestibular),
          mesial: colorCondicion(condicionMesial),
          distal: colorCondicion(condicionDistal),
          lingual: colorCondicion(condicionInterna),
          oclusal: colorCondicion(condicionOclusal),
        }}
      />

      <svg

        width={
            compact ? 54 : 70
        }

        height={
            compact ? 54 : 70
        }

        viewBox="0 0 100 100"

        style={{

          display: "none",

          overflow:
            "visible"

        }}

      >

        {/* VESTIBULAR */}

        <path

        d="
            M30 5
            L70 5
            L70 28
            L30 28
            Z
        "

        fill={
            colorCondicion(
            condicionVestibular
            )
        }

        stroke={borde}

        strokeWidth={
            grosorBorde
        }

        strokeLinejoin="round"

        />


        {/* MESIAL */}

        <path

        d="
            M5 30
            L28 30
            L28 70
            L5 70
            Z
        "

        fill={
            colorCondicion(
            condicionMesial
            )
        }

        stroke={borde}

        strokeWidth={
            grosorBorde
        }

        strokeLinejoin="round"

        />


        {/* OCLUSAL / CENTRO */}

        <rect

        x="30"

        y="30"

        width="40"

        height="40"

        rx="4"

        fill={
            colorCondicion(
            condicionOclusal
            )
        }

        stroke={borde}

        strokeWidth={
            grosorBorde
        }

        />


        {/* DISTAL */}

        <path

        d="
            M72 30
            L95 30
            L95 70
            L72 70
            Z
        "

        fill={
            colorCondicion(
            condicionDistal
            )
        }

        stroke={borde}

        strokeWidth={
            grosorBorde
        }

        strokeLinejoin="round"

        />


        {/* PALATINA / LINGUAL */}

        <path

        d="
            M30 72
            L70 72
            L70 95
            L30 95
            Z
        "

        fill={
            colorCondicion(
            condicionInterna
            )
        }

        stroke={borde}

        strokeWidth={
            grosorBorde
        }

        strokeLinejoin="round"

        />

        {/* NÚMERO */}

        <text

          x="50"

          y="54"

          textAnchor="middle"

          dominantBaseline="middle"

          fontSize={
            compact ? 11 : 13
          }

          fontWeight="800"

          fill="#334155"

        >

          {numero}

        </text>


        {/* INDICADOR DE CONDICIÓN */}

        {tieneCondicion && (

          <circle

            cx="87"

            cy="13"

            r="5"

            fill="#2563eb"

          />

        )}

      </svg>


      <div

        style={{

          marginTop: 2,

          width: "100%",

          fontSize:
            compact ? 8 : 9,

          fontWeight: 700,

          color: "#475569",

          lineHeight: 1.15,

          textAlign: "center",

          whiteSpace:
            "normal",

          overflowWrap:
            "anywhere",

          wordBreak:
            "break-word"

        }}

      >

        {condicionDiente
          || "—"}

      </div>

    </button>

  );

}


export default function MobileOdontograma({

  value = {},

  onChange

}) {


  const [

    cuadrante,

    setCuadrante

  ] = useState(

    "Superior derecho"

  );


  const [

    seleccionado,

    setSeleccionado

  ] = useState(null);


  const [

    denticion,

    setDenticion

  ] = useState(

    "permanente"

  );


  const [

    editorAbierto,

    setEditorAbierto

  ] = useState(false);


  const [

    condicionEditada,

    setCondicionEditada

  ] = useState("");

  const [busquedaCondicion, setBusquedaCondicion] = useState("");

  const [
    caraSeleccionada,
    setCaraSeleccionada
  ] = useState(null);

  const [
    condicionesCarasEditadas,
    setCondicionesCarasEditadas
  ] = useState({});


  const dientes =

    useMemo(() => {

      if (

        denticion ===

        "temporal"

      ) {

        return [];

      }


      return (

        CUADRANTES[

          cuadrante

        ] || []

      );

    }, [

      cuadrante,

      denticion

    ]);


  const seleccionarDiente = (

    numero

  ) => {

    setSeleccionado(
      numero
    );

  };


  const obtenerRegistroSeleccionado =

    () => {

      if (
        !seleccionado
      ) {

        return null;

      }


      return obtenerCondicion(

        value,

        seleccionado

      );

    };


  const registro =

    obtenerRegistroSeleccionado();

  const condicionesFiltradas = useMemo(() => {
    const query = busquedaCondicion.trim().toLocaleLowerCase();

    if (!query) return CONDICIONES;

    return CONDICIONES.filter((condicion) =>
      condicion.toLocaleLowerCase().includes(query)
    );
  }, [busquedaCondicion]);

  const obtenerCarasDiente = (
    diente
    ) => {

    const esSuperior =
        diente.startsWith("1") ||
        diente.startsWith("2");

    return [

        {
        key: "mesial",
        label: "Mesial"
        },

        {
        key: "distal",
        label: "Distal"
        },

        {
        key: "vestibular",
        label: "Vestibular"
        },

        {
        key: esSuperior
            ? "palatina"
            : "lingual",

        label: esSuperior
            ? "Palatina"
            : "Lingual"
        },

        {
        key: "oclusal",
        label: "Oclusal"
        }

    ];

    };


    const obtenerCondicionCara = (
    diente,
    cara
    ) => {

    if (
        !diente ||
        !cara
    ) {

        return "";

    }


    const registro =
        value?.[
        `${diente}_${cara}`
        ];


    return registro?.condicion
        || "";

    };


    const seleccionarCara = (
        cara
        ) => {

        setCaraSeleccionada(
            cara
        );


        setCondicionesCarasEditadas(
            anteriores => {

            if (
                Object.prototype.hasOwnProperty.call(
                anteriores,
                cara
                )
            ) {

                return anteriores;

            }


            return {

                ...anteriores,

                [cara]:
                obtenerCondicionCara(
                    seleccionado,
                    cara
                )

            };

            }
        );

    };

  const abrirEditor = () => {

    if (
        !seleccionado
    ) {

        return;

    }


    const registroActual =
        obtenerCondicion(
        value,
        seleccionado
        );


    setCondicionEditada(

        registroActual?.tipo ===
        "diente"

        ? registroActual.condicion
            || ""

        : ""

    );


    const condicionesGuardadas =
        {};


    obtenerCarasDiente(
        seleccionado
    ).forEach(cara => {

        condicionesGuardadas[
        cara.key
        ] =
        obtenerCondicionCara(
            seleccionado,
            cara.key
        );

    });


    setCondicionesCarasEditadas(
        condicionesGuardadas
    );


    setCaraSeleccionada(
        null
    );

    setBusquedaCondicion("");


    setEditorAbierto(
        true
    );

  };

  const guardarCondicion = () => {

    if (
        !seleccionado
    ) {

        return;

    }


    const nuevoOdontograma = {

        ...(value || {})

    };


    /*
    * SANO / DIENTE AUSENTE
    *
    * Estas condiciones eliminan
    * las condiciones de las caras.
    */

    if (

        condicionEditada ===
        "Sano" ||

        condicionEditada ===
        "Diente Ausente"

    ) {

        Object.keys(
        nuevoOdontograma
        ).forEach(key => {

        if (

            key === seleccionado ||

            key.startsWith(
            `${seleccionado}_`
            )

        ) {

            delete nuevoOdontograma[
            key
            ];

        }

        });


        nuevoOdontograma[
        seleccionado
        ] = {

        tipo:
            "diente",

        condicion:
            condicionEditada

        };

    }

    /*
    * OTRA CONDICIÓN GENERAL
    *
    * Solamente modifica el diente.
    * NO toca las superficies.
    */

    else if (
        condicionEditada
    ) {

        nuevoOdontograma[
        seleccionado
        ] = {

        tipo:
            "diente",

        condicion:
            condicionEditada

        };

    }

    /*
    * SIN CONDICIÓN
    *
    * Quitamos solamente la
    * condición general.
    */

    else {

        delete nuevoOdontograma[
        seleccionado
        ];

    }


    /*
    * GUARDAR TODAS LAS CARAS
    */

    Object.entries(
        condicionesCarasEditadas
    ).forEach(
        ([cara, condicion]) => {

        const key =
            `${seleccionado}_${cara}`;


        if (
            condicion
        ) {

            nuevoOdontograma[
            key
            ] = {

            tipo:
                "cara",

            condicion:
                condicion

            };

        } else {

            delete nuevoOdontograma[
            key
            ];

        }

        }
    );


    /*
    * GUARDAR EN EL PACIENTE
    */

    if (
        typeof onChange ===
        "function"
    ) {

        onChange(
        nuevoOdontograma
        );

    }


    setEditorAbierto(
        false
    );


    setCaraSeleccionada(
        null
    );


    setCondicionesCarasEditadas(
        {}
    );

  };

  const guardarCondicionCara = () => {

    if (
        !seleccionado ||
        !caraSeleccionada
    ) {

        return;

    }


    setCondicionesCarasEditadas(
        anteriores => ({

        ...anteriores,

        [caraSeleccionada]:
            condicionesCarasEditadas[
            caraSeleccionada
            ] || ""

        })
    );

  };

  const cuadranteActivo =

    Object.keys(

      CUADRANTES

    ).indexOf(

      cuadrante

    );


  return (

    <div

      style={{

        width: "100%",

        boxSizing:
          "border-box",

        padding: 12

      }}

    >

      {/* ENCABEZADO */}

      <div

        style={{

          marginBottom: 16

        }}

      >

        <div

          style={{

            fontSize: 22,

            fontWeight: 800,

            color: "#111827"

          }}

        >

          Odontograma

        </div>


        <div

          style={{

            marginTop: 4,

            fontSize: 13,

            color: "#64748b",

            lineHeight: 1.4

          }}

        >

          Selecciona un cuadrante

          y después el diente que

          deseas revisar.

        </div>

      </div>


      {/* TIPO DE DENTICIÓN */}

      <div

        style={{

          display: "flex",

          gap: 8,

          marginBottom: 14

        }}

      >

        <button

          type="button"

          onClick={() => {

            setDenticion(
              "permanente"
            );

            setSeleccionado(
              null
            );

          }}

          style={{

            flex: 1,

            padding:
              "11px 8px",

            border:
              denticion ===
              "permanente"

                ? "2px solid #2563eb"

                : "1px solid #d1d5db",

            background:
              denticion ===
              "permanente"

                ? "#eff6ff"

                : "#ffffff",

            color:
              denticion ===
              "permanente"

                ? "#1d4ed8"

                : "#475569",

            borderRadius: 12,

            fontWeight: 800,

            fontSize: 13

          }}

        >

          Permanentes

        </button>


        <button

          type="button"

          onClick={() => {

            setDenticion(
              "temporal"
            );

            setSeleccionado(
              null
            );

          }}

          style={{

            flex: 1,

            padding:
              "11px 8px",

            border:
              denticion ===
              "temporal"

                ? "2px solid #2563eb"

                : "1px solid #d1d5db",

            background:
              denticion ===
              "temporal"

                ? "#eff6ff"

                : "#ffffff",

            color:
              denticion ===
              "temporal"

                ? "#1d4ed8"

                : "#475569",

            borderRadius: 12,

            fontWeight: 800,

            fontSize: 13

          }}

        >

          Temporales

        </button>

      </div>


      {denticion ===
      "permanente" ? (

        <>

          {/* CUADRANTES */}

          <div

            style={{

              display: "grid",

              gridTemplateColumns:
                "1fr 1fr",

              gap: 8,

              marginBottom: 16

            }}

          >

            {Object.keys(

              CUADRANTES

            ).map(

              (
                nombre,
                index
              ) => (

                <button

                  key={nombre}

                  type="button"

                  onClick={() => {

                    setCuadrante(
                      nombre
                    );

                    setSeleccionado(
                      null
                    );

                  }}

                  style={{

                    padding:
                      "12px 8px",

                    borderRadius: 12,

                    border:
                      cuadranteActivo ===
                      index

                        ? "2px solid #2563eb"

                        : "1px solid #e2e8f0",

                    background:
                      cuadranteActivo ===
                      index

                        ? "#eff6ff"

                        : "#ffffff",

                    color:
                      cuadranteActivo ===
                      index

                        ? "#1d4ed8"

                        : "#334155",

                    fontWeight: 800,

                    fontSize: 12,

                    lineHeight: 1.25

                  }}

                >

                  {nombre}

                </button>

              )

            )}

          </div>


          {/* CUADRANTE ACTUAL */}

          <div

            style={{

              background:
                "#ffffff",

              border:
                "1px solid #e5e7eb",

              borderRadius: 16,

              padding: 12,

              marginBottom: 14,

              boxShadow:
                "0 2px 8px rgba(15,23,42,.04)"

            }}

          >

            <div

              style={{

                display: "flex",

                alignItems:
                  "center",

                justifyContent:
                  "space-between",

                marginBottom: 12

              }}

            >

              <div

                style={{

                  fontSize: 15,

                  fontWeight: 800,

                  color: "#111827"

                }}

              >

                {cuadrante}

              </div>


              <div

                style={{

                  fontSize: 12,

                  color: "#64748b",

                  fontWeight: 700

                }}

              >

                {dientes.length}

                {" "}

                dientes

              </div>

            </div>


            <div className="vd-mobile-odontograma-strip-wrap">
              <div
                className="vd-mobile-odontograma-scroll-hint"
                role="note"
              >
                <span>Desliza para ver las demás piezas</span>
                <span aria-hidden="true">↔</span>
              </div>

              <div
                className="vd-mobile-odontograma-strip"
                role="region"
                aria-label={`Piezas del ${cuadrante}. Desliza horizontalmente para ver todas.`}
              >

              {dientes.map(

                diente => (

                  <Tooth

                    key={diente}

                    numero={diente}

                    odontograma={
                      value
                    }

                    seleccionado={
                      seleccionado
                    }

                    onSelect={
                      seleccionarDiente
                    }

                  />

                )

              )}

              </div>

              <div
                className="vd-mobile-odontograma-strip-fade"
                aria-hidden="true"
              />
            </div>

          </div>

        </>

      ) : (

        /* TEMPORALES */

        <div

          style={{

            background:
              "#ffffff",

            border:
              "1px solid #e5e7eb",

            borderRadius: 16,

            padding: 12,

            boxShadow:
              "0 2px 8px rgba(15,23,42,.04)"

          }}

        >

          <div

            style={{

              fontSize: 15,

              fontWeight: 800,

              color: "#111827",

              marginBottom: 12

            }}

          >

            Dentición temporal

          </div>


          <div

            style={{

              display: "flex",

              flexDirection:
                "column",

              gap: 10

            }}

          >

            {TEMPORALES.map(

              (
                fila,
                index
              ) => (

                <div

                    key={index}

                    style={{

                        display: "grid",

                        gridTemplateColumns:
                        "repeat(5, minmax(0, 1fr))",

                        gap: 4,

                        width: "100%",

                        boxSizing:
                        "border-box",

                        paddingBottom: 6,

                        alignItems: "start"

                    }}

                >

                  {fila.map(

                    diente => (

                      <Tooth

                        key={diente}

                        numero={diente}

                        odontograma={
                            value
                        }

                        seleccionado={
                            seleccionado
                        }

                        onSelect={
                            seleccionarDiente
                        }

                        compact

                      />

                    )

                  )}

                </div>

              )

            )}

          </div>

        </div>

      )}


      {/* DIENTE SELECCIONADO */}

      {seleccionado && (

        <div

          style={{

            marginTop: 14,

            background:
              "#ffffff",

            border:
              "2px solid #2563eb",

            borderRadius: 16,

            padding: 16,

            boxShadow:
              "0 4px 12px rgba(15,23,42,.06)"

          }}

        >

          <div

            style={{

              display: "flex",

              alignItems:
                "center",

              justifyContent:
                "space-between",

              marginBottom: 10

            }}

          >

            <div>

              <div

                style={{

                  fontSize: 12,

                  color: "#64748b",

                  fontWeight: 700

                }}

              >

                Diente seleccionado

              </div>


              <div

                style={{

                  fontSize: 26,

                  fontWeight: 900,

                  color: "#2563eb"

                }}

              >

                {seleccionado}

              </div>

            </div>


            <button

              type="button"

              onClick={() =>
                setSeleccionado(
                  null
                )
              }

              style={{

                border: "none",

                background:
                  "#f1f5f9",

                color: "#475569",

                width: 36,

                height: 36,

                borderRadius: 10,

                fontSize: 18,

                fontWeight: 800

              }}

            >

              ×

            </button>

          </div>


          <div

            style={{

              padding: 12,

              borderRadius: 12,

              background:
                "#f8fafc",

              fontSize: 14,

              color: "#475569"

            }}

          >

            {registro?.condicion ? (

              <>

                <strong>
                  Condición:
                </strong>

                {" "}

                {registro.condicion}

              </>

            ) : (

              "Sin condiciones registradas."

            )}

          </div>


          <button

            type="button"

            onClick={
              abrirEditor
            }

            style={{

              width: "100%",

              marginTop: 12,

              padding: 13,

              border: "none",

              borderRadius: 12,

              background:
                "#2563eb",

              color: "#ffffff",

              fontWeight: 800,

              fontSize: 14

            }}

          >

            Ver y editar diente

          </button>

        </div>

      )}


      {/* EDITOR DEL DIENTE */}

        {editorAbierto &&
        seleccionado && (

        <div

            style={{

            position: "fixed",

            left: 0,

            right: 0,

            top: 0,

            bottom: 90,

            zIndex: 1000,

            background:
                "rgba(15,23,42,.45)",

            display: "flex",

            alignItems: "flex-end",

            justifyContent: "center",

            padding: 12,

            paddingBottom: 12,

            boxSizing:
                "border-box",

            overflow: "hidden"

            }}

        >

            <div

            style={{

                width: "100%",

                maxWidth: 520,

                maxHeight:
                "calc(100dvh - 114px)",

                background:
                "#ffffff",

                borderRadius:
                "20px 20px 14px 14px",

                padding: 18,

                boxSizing:
                "border-box",

                boxShadow:
                "0 -8px 30px rgba(15,23,42,.18)",

                overflowY: "auto",

                WebkitOverflowScrolling:
                "touch"

            }}

            >

            <div

                style={{

                display: "flex",

                alignItems:
                    "center",

                justifyContent:
                    "space-between",

                marginBottom: 16

                }}

            >

                <div>

                <div

                    style={{

                    fontSize: 12,

                    color: "#64748b",

                    fontWeight: 700

                    }}

                >

                    Editar diente

                </div>


                <div

                    style={{

                    marginTop: 2,

                    fontSize: 24,

                    color: "#2563eb",

                    fontWeight: 900

                    }}

                >

                    {seleccionado}

                </div>

                </div>


                <button

                type="button"

                onClick={() =>
                    setEditorAbierto(
                    false
                    )
                }

                style={{

                    border: "none",

                    background:
                    "#f1f5f9",

                    color: "#475569",

                    width: 38,

                    height: 38,

                    borderRadius: 10,

                    fontSize: 20,

                    fontWeight: 800,

                    flexShrink: 0

                }}

                >

                ×

                </button>

            </div>


            <div

                style={{

                marginBottom: 8,

                fontSize: 13,

                fontWeight: 800,

                color: "#334155"

                }}

            >

                Condición del diente

            </div>

            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    marginBottom: 8,
                    padding: "0 11px",
                    border: "1px solid #cbd5e1",
                    borderRadius: 12,
                    background: "#ffffff"
                }}
            >
                <span style={{ color: "#64748b", fontSize: 16 }}>⌕</span>
                <input
                    type="search"
                    value={busquedaCondicion}
                    onChange={e => setBusquedaCondicion(e.target.value)}
                    placeholder="Buscar diagnóstico o condición..."
                    style={{
                        width: "100%",
                        padding: "12px 0",
                        border: "none",
                        outline: "none",
                        background: "transparent",
                        color: "#1e293b",
                        fontSize: 14
                    }}
                />
            </div>


            <select

                value={
                condicionEditada
                }

                onChange={e =>
                setCondicionEditada(
                    e.target.value
                )
                }

                style={{

                width: "100%",

                padding:
                    "13px 12px",

                border:
                    "1px solid #cbd5e1",

                borderRadius: 12,

                background:
                    "#ffffff",

                color: "#1e293b",

                fontSize: 14,

                boxSizing:
                    "border-box"

                }}

            >

                <option value="">

                Sin condición

                </option>


                {condicionesFiltradas.map(

                condicion => (

                    <option

                    key={condicion}

                    value={condicion}

                    >

                    {condicion}

                    </option>

                )

                )}

            </select>

            <div
                style={{
                    marginTop: 20,
                    marginBottom: 10,
                    fontSize: 13,
                    fontWeight: 800,
                    color: "#334155"
                }}
                >
                Superficies
                </div>


                <div
                style={{
                    display: "grid",
                    gridTemplateColumns:
                    "1fr 1fr",
                    gap: 8
                }}
                >

                {obtenerCarasDiente(
                    seleccionado
                ).map(cara => {

                    const condicionCara =
                        Object.prototype.hasOwnProperty.call(
                            condicionesCarasEditadas,
                            cara.key
                        )
                            ? condicionesCarasEditadas[
                                cara.key
                            ]
                            : obtenerCondicionCara(
                                seleccionado,
                                cara.key
                            );


                    const activa =
                    caraSeleccionada ===
                    cara.key;


                    return (

                    <button

                        key={cara.key}

                        type="button"

                        onClick={() =>
                        seleccionarCara(
                            cara.key
                        )
                        }

                        style={{

                        padding:
                            "11px 10px",

                        border:
                            activa

                            ? "2px solid #2563eb"

                            : condicionCara

                                ? "2px solid #94a3b8"

                                : "1px solid #d1d5db",

                        borderRadius: 12,

                        background:
                            activa

                            ? "#eff6ff"

                            : condicionCara

                                ? "#f8fafc"

                                : "#ffffff",

                        color:
                            activa

                            ? "#1d4ed8"

                            : "#475569",

                        fontWeight: 800,

                        fontSize: 13,

                        textAlign:
                            "left"

                        }}

                    >

                        <div>

                        {cara.label}

                        </div>


                        {condicionCara && (

                        <div

                            style={{

                            marginTop: 3,

                            fontSize: 11,

                            fontWeight: 600,

                            color: "#64748b",

                            whiteSpace:
                                "normal",

                            overflowWrap:
                                "anywhere"

                            }}

                        >

                            {condicionCara}

                        </div>

                        )}

                    </button>

                    );

                })}

            </div>

            {caraSeleccionada && (

                <div

                    style={{

                    marginTop: 12,

                    padding: 12,

                    borderRadius: 12,

                    background: "#f8fafc",

                    border:
                        "1px solid #e2e8f0"

                    }}

                >

                    <div

                    style={{

                        marginBottom: 8,

                        fontSize: 12,

                        fontWeight: 800,

                        color: "#334155"

                    }}

                    >

                    Condición de la cara

                    </div>


                    <select

                    value={
                        caraSeleccionada
                            ? (
                                condicionesCarasEditadas[
                                caraSeleccionada
                                ] || ""
                            )
                            : ""
                        }

                        onChange={e => {

                        if (
                            !caraSeleccionada
                        ) {

                            return;

                        }


                        setCondicionesCarasEditadas(
                            anteriores => ({

                            ...anteriores,

                            [caraSeleccionada]:
                                e.target.value

                            })
                        );

                    }}

                    style={{

                        width: "100%",

                        padding:
                        "12px",

                        border:
                        "1px solid #cbd5e1",

                        borderRadius: 10,

                        background:
                        "#ffffff",

                        color: "#1e293b",

                        fontSize: 14,

                        boxSizing:
                        "border-box"

                    }}

                    >

                    <option value="">

                        Sin condición

                    </option>


                    {condicionesFiltradas.map(

                        condicion => (

                        <option

                            key={condicion}

                            value={condicion}

                        >

                            {condicion}

                        </option>

                        )

                    )}

                    </select>


                    <button

                    type="button"

                    onClick={
                        guardarCondicionCara
                    }

                    style={{

                        width: "100%",

                        marginTop: 8,

                        padding: 11,

                        border: "none",

                        borderRadius: 10,

                        background:
                        "#e0ecff",

                        color:
                        "#1d4ed8",

                        fontWeight: 800,

                        fontSize: 13

                    }}

                    >

                    Guardar condición de esta cara

                    </button>

                </div>

            )}

            <div

                style={{

                    marginTop: 8,

                    fontSize: 12,

                    lineHeight: 1.4,

                    color: "#64748b"

                }}

                >

                La condición del diente y las
                condiciones de sus superficies
                se pueden registrar de forma
                independiente.

            </div>


            <div

                style={{

                display: "flex",

                gap: 8,

                marginTop: 18,

                paddingBottom: 2

                }}

            >

                <button

                type="button"

                onClick={() =>
                    setEditorAbierto(
                    false
                    )
                }

                style={{

                    flex: 1,

                    padding: 13,

                    border:
                    "1px solid #d1d5db",

                    borderRadius: 12,

                    background:
                    "#ffffff",

                    color: "#475569",

                    fontWeight: 800,

                    fontSize: 14

                }}

                >

                Cancelar

                </button>


                <button

                type="button"

                onClick={
                    guardarCondicion
                }

                style={{

                    flex: 1,

                    padding: 13,

                    border: "none",

                    borderRadius: 12,

                    background:
                    "#2563eb",

                    color: "#ffffff",

                    fontWeight: 800,

                    fontSize: 14

                }}

                >

                Guardar

                </button>

            </div>

            </div>

        </div>

      )}

      {/* RESUMEN */}

      <div

        style={{

          marginTop: 14,

          background:
            "#f8fafc",

          borderRadius: 14,

          padding: 14

        }}

      >

        <div

          style={{

            fontSize: 13,

            fontWeight: 800,

            color: "#334155",

            marginBottom: 6

          }}

        >

          Resumen

        </div>


        <div

          style={{

            fontSize: 12,

            color: "#64748b"

          }}

        >

          {Object.keys(

            value || {}

          ).length}

          {" "}

          registros en el

          odontograma.

        </div>

      </div>

    </div>

  );

}
